import type { UpdateProfileDTO } from 'app/types/profile';
import { isFeatureEnabled, FeatureFlag } from 'app/utils/helpers';
import * as yup from 'yup';

export type ProfileInformationFormValues = Omit<UpdateProfileDTO, 'picture'>;

export const getSchema = (_t: (key: string) => string): yup.ObjectSchema<ProfileInformationFormValues> => {
  return yup.object({
    additionalName: yup.string().max(255).trim().nullable().optional(),
    firstName: yup.string().min(2).max(255).trim().required(),
    lastName: yup
      .string()
      .max(255)
      .trim()
      .when({
        is: () => isFeatureEnabled(FeatureFlag.lastName),
        then: (s) => s.min(2).required(),
        otherwise: (s) => s.optional(),
      }),
    phone: yup
      .string()
      .trim()
      .required()
      .transform((value: string) => {
        if (!value) return value;
        // Keep only digits, - . spaces and leading "+"
        return value.replace(/[^+\d-. ]/g, '');
      }),
    // Not working - form always show this field as invalid when we change the value; disabling for now
    // .test('is-valid-phone', t('phoneFieldError'), function (value) {
    //   if (!value) return false;
    //   return phoneRegExp.test(value);
    // }),
    bio: yup.string().trim().defined().optional(),
    email: yup.string().trim().email().required(),
    groupIds: yup.array(yup.string().uuid().defined()).optional(),
  });
};
